import { render, staticRenderFns } from "./Finances.vue?vue&type=template&id=5023b4e2&"
import script from "./Finances.vue?vue&type=script&lang=js&"
export * from "./Finances.vue?vue&type=script&lang=js&"
import style0 from "./Finances.vue?vue&type=style&index=0&id=5023b4e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports